// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"ControlPanel__buttonsWrapper___1dK05"};